<template>
  <v-divider class="border-opacity-100 w-50 mx-auto" style="max-width: 500px; z-index: 1;" color=primary thickness=2 />
</template>